export const ENABLE_MEDICINE_INTEGRATIONS =
  process.env.REACT_APP_ENABLE_MEDICINE_INTEGRATIONS?.toString() === 'true';

export const ENABLE_API_KEY_MANAGEMENT =
  process.env.REACT_APP_ENABLE_API_KEY_MANAGEMENT?.toString() === 'true';
